import { useEffect, useState } from 'react';

import { fetchPriceChart } from '../utils/api/coingecko/coingecko';

type PriceChartError = {
    message: string;
};

const usePriceChart = (slug: string, vsCurrency: string, unixFrom: number, unixTo: number) => {
    const [isLoading, setIsLoading] = useState(false);
    const [priceChartError, setPriceChartError] = useState<PriceChartError | null>(null);
    const [priceChart, setPriceChart] = useState<any>();

    useEffect(() => {
        if (!slug) {
            setIsLoading(false);
            setPriceChartError({ message: 'Price chart not available.' });
            return;
        }

        setIsLoading(true);

        const fetchData = async () => {
            fetchPriceChart(slug, vsCurrency, unixFrom, unixTo)
                .then(res => {
                    if (!res) {
                        setPriceChartError({ message: 'Error fetching price chart.' });
                        setIsLoading(false);
                        return;
                    }

                    setIsLoading(false);
                    setPriceChart(res);
                    setPriceChartError(null);
                })
                .catch(e => {
                    setPriceChartError({ message: `Error fetching price chart: ${e}` });
                    setIsLoading(false);
                });

            setPriceChartError(null);
        };

        fetchData();
    }, [unixFrom, slug, vsCurrency]);

    return { priceChart, priceChartError, isLoading };
};

export default usePriceChart;
